import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormsService } from '../../../services/forms.service';
import { ApiService } from '../../../services/api.service';
import { NotificationService } from '../../notification/notification.service';
import { UserService } from '../../../services/user.service';
import { IFormField, InputTypes } from '../../../models/formField';
import {
  IPayPalConfig,
  ICreateOrderRequest
} from 'ngx-paypal';
import { FormResultMessageFormat } from '../../notification/notification';
import { ProductService } from '../../../services/product.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { LicenseTypes } from '../../../models/product';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';


function SmoothScroll(target, speed, smooth) {
	if (target === document)
		target = (document.scrollingElement
              || document.documentElement
              || document.body.parentNode
              || document.body) // cross browser support for document scrolling

	var moving = false
	var pos = target.scrollTop
  var frame = target === document.body
              && document.documentElement
              ? document.documentElement
              : target // safari is the new IE

	target.addEventListener('mousewheel', scrolled, { passive: false })
	target.addEventListener('DOMMouseScroll', scrolled, { passive: false })

	function scrolled(e) {
		e.preventDefault(); // disable default scrolling

		var delta = normalizeWheelDelta(e)

		pos += -delta * speed
		pos = Math.max(0, Math.min(pos, (target.scrollHeight - frame.clientHeight) + (smooth * 2))) // limit scrolling

		if (!moving) update()
	}

	function normalizeWheelDelta(e){
		if(e.detail){
			if(e.wheelDelta)
				return e.wheelDelta/e.detail/40 * (e.detail>0 ? 1 : -1) // Opera
			else
				return -e.detail/3 // Firefox
		}else
			return e.wheelDelta/120 // IE,Safari,Chrome
	}

	function update() {
		moving = true

		var delta = (pos - target.scrollTop) / smooth

		target.scrollTop += delta

		if (Math.abs(delta) > 0.5)
			requestFrame(update)
		else
			moving = false
	}

	var requestFrame = function() { // requestAnimationFrame cross browser
		return (
			window.requestAnimationFrame ||
			// window.webkitRequestAnimationFrame ||
			// window.mozRequestAnimationFrame ||
			// window.oRequestAnimationFrame ||
			// window.msRequestAnimationFrame ||
			function(func) {
				window.setTimeout(func, 1000 / 50);
			}
		);
	}()
}

@Component({
  selector: 'lib-ng-paypal-form',
  templateUrl: './ng-paypal-form.component.html',
  styleUrls: ['./ng-paypal-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NgPaypalFormComponent implements OnInit {

  public payPalConfig ? : IPayPalConfig;

  private totalCost = "$0.00 USD";

  premiumLicense = false;

  smoothScroll: () => void;
  loading = false;
  @Output() closeForm = new EventEmitter;

  paypalFormSettings: {} = {};
  paypalForm: FormGroup;
  formReady = false;

  paypalPreForm: IFormField[] = [
    {
      inputName: "uses",
      inputType: InputTypes.select,
      placeholder: "Select",
      value: "",
      id: "usesId",
      label: "Uses"
    },
    {
      inputName: "totalPrice",
      inputType: InputTypes.number,
      placeholder: "",
      value: "",
      id: "totalPriceId",
      label: "Total Price"
    }
  ];

  modalRef: BsModalRef;

  discountByUses:{uses:number,discount:number}[] = [
    {uses: 5, discount: 0},
    {uses: 10, discount: 10},
    {uses: 15, discount: 20},
    {uses: 25, discount: 30},
    {uses: 50, discount: 40},
    {uses: 100, discount: 50}
  ];

  @ViewChild('licenseErrorMessage')
    licenseErrorMessage: TemplateRef<any>;

  paypalDicabled = true;

  @ViewChild('paypalContainer')
    paypalContainer:TemplateRef<any>;

  @ViewChild('paypalModal')
    paypalModal: TemplateRef<any>;

  _notificationSvc: NotificationService;

  userLoggedIn: boolean;

  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private authService: AuthService,
    private formService: FormsService,
    private apiService: ApiService,
    private notif: NotificationService,
    private userService: UserService,
    private productService: ProductService
  ) {
    this._notificationSvc = new NotificationService();
    console.log(router.url)
  }

  ngOnInit(): void {
    this.userLoggedIn = !!this.userService.currentUser;
    this.premiumLicense = this.checkForPremmium(this.userLoggedIn);
    this.userService.userUpdated.subscribe(user => {
      this.userLoggedIn = !!user;
      setTimeout(() => {
        this.premiumLicense = this.checkForPremmium(this.userLoggedIn);
      }, 500);
    });
    setTimeout(() => {
      let usesFromStorage = localStorage.getItem('UsageLicenseUses');
      if (usesFromStorage) {
        localStorage.removeItem('UsageLicenseUses');
        this.paypalForm.get("uses").setValue(parseInt(usesFromStorage));
        this.paypalForm.get("uses").updateValueAndValidity();
        setTimeout(() => {
          this.updateTotalPrice();
          this.modalRef = this.modalService.show(this.paypalModal);
        }, 200);

      }
    }, 1000);

    this.initConfig(1);
    this.smoothScroll = new SmoothScroll(document.getElementsByTagName('lib-ng-paypal-form')[0],120,12);
    let settings = {};

    let form = this.formService.createForm('paypal', this.paypalPreForm);

    form.forEach(el => {
      this.paypalFormSettings[el.inputName] = el;
    });

    let formReactive = this.formService.convertToReactiveForm(form);
    this.paypalForm = this.fb.group(formReactive);
    this.formReady = true;



  }

  private checkForPremmium(userLoggedIn): boolean {
    if(userLoggedIn) {
      let licenseType = "";
      let highestLicenseId = this.productService.getPremiumLicenseId();
      if(!!highestLicenseId) {
        let highestLicense = this.productService.getLicenseById(highestLicenseId);
        licenseType = this.productService.getTypeItemNew(highestLicense.licenseParams.type).name;
        console.log(licenseType);
      }
      return ["EnterpriseLicense", "ProjectLicense"].includes(licenseType);
    } else {
      return false;
    }

  }

  protected updateTotalPrice(): void {
    if (this.paypalForm.get('uses').value) {
      let discount = (100 - this.discountByUses.find(x => x.uses === this.paypalForm.get('uses').value).discount) / 100;
      let val = this.paypalForm.get('uses').value * 10 * discount;
      this.totalCost = `$${val}.00 USD`;
      this.initConfig(val);
      this.paypalDicabled = false;
  } else {
      this.totalCost = "$0.00 USD";
    }

  }

  submit(): void {
    if(!!this.userLoggedIn) {
      // TODO Show paypal modal

      this.modalRef = this.modalService.show(this.paypalModal);
      // this.notif.info(`Submit payment of: ${this.totalCost}`,"",FormResultMessageFormat.modalHtml,0,this.paypalModal,false);
    } else {
      this.Login();
    }
  }

  Login() {
    localStorage.setItem('UsageLicenseUses', this.paypalForm.value.uses);
    this.authService.login('/paypal');
  }


  private initConfig(val: any): void {
    this.payPalConfig = {
        currency: 'USD',
        clientId: 'AYxb3NkzMxDRqWHM1zEMKoNPbhid2uqWGlKDhser3YNuol9F1l5x-vboasxiJ7AbvmlsLaB1MrdfyYHS',
        createOrderOnServer: (data) => fetch('/my-server/create-paypal-transaction')
                .then((res) => res.json())
                .then((order) => order.orderID),
            onApprove: (data, actions) => {
                console.log('onApprove - transaction was approved, but not authorized', data, actions);
                actions.order.get().then(details => {
                    console.log('onApprove - you can get full order details inside onApprove: ', details);
                });

            },
        // createOrderOnClient: (data) => < ICreateOrderRequest > {
        //     intent: 'CAPTURE',
        //     purchase_units: [{
        //         amount: {
        //             currency_code: 'USD',
        //             value: val,
        //             breakdown: {
        //                 item_total: {
        //                     currency_code: 'USD',
        //                     value: val
        //                 }
        //             }
        //         },
        //         items: [{
        //             name: 'Developer License',
        //             quantity: '1',
        //             category: 'DIGITAL_GOODS',
        //             unit_amount: {
        //                 currency_code: 'USD',
        //                 value: val,
        //             },
        //         }]
        //     }]
        // },
        advanced: {
            commit: 'true'
        },
        style: {
            label: 'paypal',
            layout: 'vertical'
        },
        // onApprove: (data, actions) => {
        //     console.log('onApprove - transaction was approved, but not authorized', data, actions);
        //     actions.order.get().then(details => {
        //         // console.log('onApprove - you can get full order details inside onApprove: ', details);
        //         // console.log(JSON.stringify(details, null, 4))

        //     });

        // },
        onClientAuthorization: (data) => {
            // console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
            this.modalRef.hide();
            this.getUsageLicense(this.paypalForm.value.uses,data);
        },
        onCancel: (data, actions) => {
            // console.log('OnCancel', data, actions);

        },
        onError: err => {
            // console.log('OnError', err);
            this.modalRef.hide();
        },
        onClick: (data, actions) => {
            // console.log('onClick', data, actions);
        }
    };
}

  cancel() {
    // clear form
    // go back
    this.closeForm.emit();
  }

  private sendMessage(success: boolean,count: number, paypalData: any): void {
    let payload = new FormData();
    payload.append('type','contact');
    payload.append('contact.email',this.userService.getUserInfo().email);
    payload.append('contact.fullName',this.userService.getUserInfo().fullName);
    payload.append('contact.username',this.userService.getUserInfo().username);
    payload.append('subject',`Developer License Paypal payment`);

    let username = this.userService.getUserInfo().username;
    let userEmail = this.userService.getUserInfo().email;
    let companyId = this.userService.getCompanyId();
    let companyName = this.userService.getCompanyName();

    let content = {message: `Developer license Payment was made.
      ${(success ? 'License was successfully created' : 'License was NOT created. Please check payment and add license manually.')}.
      Number of uses: ${count}
      Company Name: ${companyName}
      Company ID: ${companyId}
      Username: ${username}
      User Email: ${userEmail}.

      PayPal log:
      ${JSON.stringify(paypalData, null, 4)}`};
    payload.append('content',JSON.stringify(content));
    this.apiService.sendSupportMessage(payload).subscribe({
      next: result => {
        this.loading = false;
        if(success) this.closeForm.emit();
      },
      error: err => {
        console.log(err);
        this.loading = false;
        if(success) this.closeForm.emit();
      }
    });

  }

  private getUsageLicense(count: number, paypalData: any) {
    this.loading = true;
    let messageBody = {
      productCategoryId: "rest_generator",
      start: new Date().toISOString().split('.')[0]+"Z",
      licenseParams: {
        type: 'UsageLicense',
        maxUses: count
      },
    }
    messageBody.licenseParams['maxUses'] = count;
    let companyId = this.userService.getCompanyId();
    let companyName = this.userService.getCompanyName();

    let licenseType = "";
    let highestLicenseId = this.productService.getPremiumLicenseId();
    if(!!highestLicenseId) {
      let highestLicense = this.productService.getLicenseById(highestLicenseId);
      licenseType = this.productService.getTypeItemNew(highestLicense.licenseParams.type).name;
    }

    if(licenseType === "UsageLicense") {
      this.apiService.addUsesToLicense(companyId,highestLicenseId,messageBody).subscribe({
        next: result =>{
          this.loading = false;
          this.notif.success('Developer License Created',`${count} uses were added to ${companyName}`,FormResultMessageFormat.popup,6000,null);
          this.productService.setLicensesFromApi();
          this.sendMessage(true,count,paypalData);

        },
        error: err => {
          this.loading = false;
          this.sendMessage(false,count,paypalData);
          this.notif.info('Developer License','',FormResultMessageFormat.modalHtml,0,this.licenseErrorMessage,false,null,null);
        }
      });
    } else {
      this.apiService.createLicense(companyId,messageBody).subscribe({
        next: result =>{
          this.loading = false;
          this.notif.success('Developer License Created',`${count} uses were added to ${companyName}`,FormResultMessageFormat.popup,6000,null);
          this.productService.setLicensesFromApi();
          this.sendMessage(true,count,paypalData);

        },
        error: err => {
          this.loading = false;
          this.sendMessage(false,count,paypalData);
          this.notif.info('Developer License','',FormResultMessageFormat.modalHtml,0,this.licenseErrorMessage,false,null,null);
        }
      });
    }


  }

}
